import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "insurance",
  "use": "insurance-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"insurance\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M2 16a14 14 0 0128 0zM16 0A16 16 0 000 16v2h14v8a6 6 0 0012 0h-2a4 4 0 01-8 0v-8h16v-2A16 16 0 0016 0z\" data-name=\"Page-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol